<div class="sidemenu" [ngClass]="{'expanded-menu': expanded}">
    <a class="sidemenu-logo" routerLink="/dashboard" aria-label="OwnRewards home">
        <img
            class="brand-mark-icon"
            src="/images/logo.png"
            width="28"
            height="28"
            alt=""
            decoding="async"
        />
        @if (expanded) {
        <span class="brand-word">Ownrewards</span>
        }
    </a>
    <div class="sidemenu-items">
        @for (section of sideMenuSections; track section.label) {
        <div class="sidemenu-section" [ngClass]="{'sidemenu-section--collapsed': !expanded}">
            @if (expanded) {
            <p class="or-nav-group-label sidemenu-section-label">{{ section.label }}</p>
            }

            @for (item of section.items; track item.path) {
            <a [routerLink]="item.path"
                class="or-nav-item sidemenu-menu"
                [class.or-nav-item--active]="isItemActive(item.path)"
                nz-tooltip
                [nzTooltipTitle]="!expanded ? item.name : ''"
                [attr.aria-current]="isItemActive(item.path) ? 'page' : null">
                <span class="sidemenu-menu-icon-wrap" aria-hidden="true">
                    @if (item.icon) {
                    <lucide-icon [name]="item.icon" [size]="18" class="sidemenu-menu-icon"></lucide-icon>
                    }
                </span>
                @if (expanded) {
                <span class="sidemenu-menu-label">{{ item.name }}</span>
                @if (item.badge) {
                <span class="or-badge badge-gold sidemenu-menu-badge">{{ item.badge }}</span>
                }
                }
            </a>
            }
        </div>
        }
    </div>

    <button type="button" class="sidemenu-toggle" [ngClass]="{'toggle-expanded': expanded}"
        (click)="toggleSidebar()" [attr.aria-label]="expanded ? 'Collapse sidebar' : 'Expand sidebar'"
        [attr.aria-expanded]="expanded">
        <lucide-icon [name]="expanded ? 'chevron-left' : 'chevron-right'" size="18"
            class="sidemenu-toggle-icon"></lucide-icon>
    </button>
</div>
